const BASE_URL = 'https://countdown-app-login.herokuapp.com';

export const API_URL = (slug) => `${BASE_URL}/${slug}`;
